import { useState } from 'react'
import { useFaqs } from '../../hooks/useFaqs'
import { appUrl } from '@astro/config'

export default function FaqSection() {
  const [open, setOpen] = useState(0)
  const { faqs: faqList } = useFaqs()

  return (
    <section className="relative overflow-hidden py-20 md:py-28 md:px-18 bg-background text-gray-800 font-normal select-none">
      <div className="pointer-events-none absolute inset-0 opacity-[0.5] -z-10">
        <div className="absolute right-1/4 top-10 w-125 h-125 rounded-full bg-[radial-gradient(circle,rgba(232,119,15,0.06)_0%,transparent_70%)] blur-3xl animate-pulse"></div>
      </div>

      <div className="container relative z-10 mx-auto px-6 max-w-350">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-28">
            <div className="space-y-6">
              <div className="space-y-3 text-left">
                <div className="flex items-center gap-3">
                  <span className="h-px w-8 bg-secondary/50"></span>
                  <span className="text-[10px] uppercase tracking-[0.4em] text-secondary font-bold">Knowledge Base</span>
                </div>
                <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl uppercase leading-tight text-primary">Frequently Asked <span className="text-gradient-gold font-bold block">Questions</span></h2>
                <p className="max-w-sm text-xs md:text-sm leading-relaxed text-gray-500 font-normal normal-case">Everything you need to know — clearly answered. Browse the common questions below.</p>
              </div>

              <div className="rounded-3xl border border-gray-200 bg-white/80 p-6 shadow-sm backdrop-blur-sm space-y-4">
                <h3 className="font-heading text-base uppercase text-primary font-bold tracking-wide">Still have a question?</h3>
                <p className="text-xs text-gray-400 font-normal leading-relaxed normal-case">If your query isn't covered in our system parameters, our team is happy to assist.</p>
                <a
                  href={appUrl("website", 'contact')}
                  className="group inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-5 h-11 text-[10px] font-bold uppercase tracking-widest text-white shadow-lg shadow-primary/10 transition-all duration-300 hover:bg-secondary w-full"
                >
                  <i className="fa-solid fa-comment-dots"></i> Contact Us <i className="fa-solid fa-arrow-right transition-transform group-hover:translate-x-1"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 space-y-3.5">
            {faqList.map((f, i) => {
              const isOpen = open === i
              return (
                <div key={i} className={`rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'border border-secondary/30 bg-white shadow-md shadow-primary/5' : 'border border-gray-200 bg-white/60 hover:bg-white hover:border-secondary/30'}`}>
                  <button type="button" onClick={() => setOpen(isOpen ? -1 : i)} className="flex w-full items-center justify-between gap-4 p-5 text-left md:p-6 outline-none group">
                    <span className="flex items-center gap-4">
                      <span className={`font-mono text-[11px] font-bold transition-colors ${isOpen ? 'text-secondary' : 'text-primary/30 group-hover:text-secondary'}`}>{String(i + 1).padStart(2, '0')}</span>
                      <span className={`font-heading text-base leading-snug font-semibold transition-colors md:text-lg ${isOpen ? 'text-primary' : 'text-primary/70 group-hover:text-primary'}`}>{f.q}</span>
                    </span>
                    <span className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition-all duration-300 ${isOpen ? 'bg-primary text-white rotate-45' : 'bg-primary/5 text-primary group-hover:bg-primary group-hover:text-white'}`}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4"><line x1="12" x2="12" y1="5" y2="19"></line><line x1="5" x2="19" y1="12" y2="12"></line></svg>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 pl-14 md:px-6 md:pb-6 md:pl-17 text-sm leading-relaxed text-gray-500 normal-case border-t border-gray-50 pt-3">{f.a}</div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
